module.exports = __webpack_public_path__ + "media/images/icons/filled/left-circle-e845a5cfda261a45180a8af953454782.svg";